import {Injectable} from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthService} from "@app/core/services/auth.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUser = this.authService.currentUserValue;
        console.log('okok -canActivate', currentUser);
        if (currentUser) {
            // authorised so return true
            return true;
        }
        
        this.router.navigate(['/auth/login'], {queryParams: {returnUrl: state.url}});
       
        return true;
    }

}
